var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import styles from './cookie-checkbox.component.scss';
import { Component, h } from 'preact';
var CookieCheckbox = /** @class */ (function (_super) {
    __extends(CookieCheckbox, _super);
    function CookieCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CookieCheckbox.prototype.render = function (props) {
        var _this = this;
        return (h("label", { class: props.required ? styles['cookie-checkbox'] + " " + styles['greyed'] : "" + styles['cookie-checkbox'], for: props.id },
            h("input", { id: props.id, name: props.name, type: "checkbox", checked: props.selected, disabled: props.required, onClick: function (ev) { _this.props.checkboxUpdate(ev, _this.props.info); } }),
            h("div", { class: styles['cookie-checkbox'] + " " + styles['cookie-checkbox-box'] }),
            h("div", { class: styles['cookie-checkbox'] + " " + styles['cookie-checkbox-label'] }, props.name)));
    };
    return CookieCheckbox;
}(Component));
export default CookieCheckbox;



//////////////////
// WEBPACK FOOTER
// ./components/cookie-checkbox/cookie-checkbox.component.tsx
// module id = null
// module chunks = 